import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaInformacionSa', NominasNominaInformacionSa)

function NominasNominaInformacionSa($http) {
  this.get = _get
  this.put = _put

  function _get(idEmpresa, idNomina) {
    return $http.get('/kendu/nominas/nomina/informacion/sa', {
      params: {idEmpresa: idEmpresa, idNomina: idNomina},
      schema: NominasNominaInformacionSaSchema,
    })
  }

  function _put(idEmpresa, idNomina, data) {
    return $http.put('/kendu/nominas/nomina/informacion/sa', data, {
      params: {idEmpresa: idEmpresa, idNomina: idNomina},
      schema: NominasNominaInformacionSaSchema,
      clearCache: 'nominas',
    })
  }

  let NominasNominaInformacionSaSchema = {
    suministro: 'number',
    carga_social: 'number',
    impuesto_estatal: 'number',
    comision_importe: 'number',
    comision_porcentaje: 'number',
    subtotal: 'number',
    iva: 'number',
    total: 'number',
    // Remunerados
    suministro_remunerados: 'number',
    carga_social_remunerados: 'number',
    impuesto_estatal_remunerados: 'number',
    impuesto_estatal_noremunerados: 'number',
    comision_importe_remunerados: 'number',
    comision_importe_noremunerados: 'number',
    comision_porcentaje_remunerados: 'number',
    subtotal_remunerados: 'number',
    iva_remunerados: 'number',
    total_remunerados: 'number',
    // No Remunerados
    suministro_noremunerados: 'number',
    carga_social_noremunerados: 'number',
    subtotal_noremunerados: 'number',
    iva_noremunerados: 'number',
    total_noremunerados: 'number',
    impuestos: {
      importe: 'number',
    },
    impuestosRemunerado: {
      importe: 'number',
    },
    impuestosNoRemunerado: {
      importe: 'number',
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Informacion/Sa.js